import React                    from 'react';
import SmallestHoleSizeCheckbox from 'pu-react/components/SmallestHoleSizeCheckbox';

const SmallestHoleSize = (props) => {
  const value = '< 8 mils';
  const name = 'smallest_hole_size';
  const onChange = (e) => props.onChangeParameter(name, e.target.checked ? value : null);
  return (
    <SmallestHoleSizeCheckbox
      {...props}
      label="Min. Hole Size < 8 mils"
      tooltip={null}
      drawHidden={false}
      checked={props.parameters[name] === value}
      onChange={onChange}
      value={value} />
  );
};

export default SmallestHoleSize;
